import { createNaturalDivisionTask, randInt, tableDivisionExplanation } from "./sharedNaturalDivision";

function pickData() {
  const b = randInt(2, 9);
  const result = randInt(2, 9);
  const a = b * result;
  return { a, b, result };
}

const mod = createNaturalDivisionTask({
  type: "NaturalDivTableTask",
  pickData,
  explain: tableDivisionExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
